import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  LOAN_APPLICATION_UPDATE_START,
} from '../../actions/types'

import {
  loanApplicationUpdateSuccess,
  loanApplicationUpdateFailed,
} from '../../actions'

import { updateLoanApplication } from '../../requesters/loanApplication'

function* loadApplicationUpdate(action) {
  let { id, source, params } = action.payload
  const { response, error } = yield call(updateLoanApplication, id, params)

  if (response) {
    yield put(loanApplicationUpdateSuccess(response))
  } else {
    yield put(loanApplicationUpdateFailed(error.response.data.errors))
  }
}

export function* watchLoanApplicationUpdate() {
  yield takeLatest(LOAN_APPLICATION_UPDATE_START, loadApplicationUpdate);
}
